module.exports = new __parcel__URL__("bugs-bunny-lost-in-time.ac1ce06e.jpg").toString();